import { computed, ComputedRef } from 'vue';
import { useDocumentProperties } from '@/composables/useDocumentProperties';

let isScrolledPastThresholdHeight: ComputedRef<boolean> | undefined;

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

export function useScrollToTop() {
  const { yScrollPosition, windowHeight } = useDocumentProperties();

  isScrolledPastThresholdHeight = isScrolledPastThresholdHeight ?? computed(() => {
    const isPageScrolledPastOnePageLength = yScrollPosition.value > (windowHeight.value / 2);

    return isPageScrolledPastOnePageLength;
  });

  return {
    isScrolledPastThresholdHeight,
    scrollToTop
  };
}
